export default "__VITE_ASSET__a0d93f75__"